(function () {
    if (window.__amVariantSkuInit) return;
    window.__amVariantSkuInit = true;

    var PROPERTY_NAME = 'properties[Artikelnummer]';
    var MARKERS = '[data-variant-sku-map],[data-variant-sku-input]';
    var registry = (window.amVariantSkus = window.amVariantSkus || {});
    var scheduled = false;

    function normalise(value) {
        return value == null ? '' : String(value);
    }

    function lookup(variantId) {
        if (!variantId) return undefined;
        return registry[String(variantId)];
    }

    function harvest(scope) {
        var root = scope || document;

        root.querySelectorAll('[data-variant-sku-map]').forEach(function (node) {
            if (node.getAttribute('data-variant-sku-harvested')) return;
            node.setAttribute('data-variant-sku-harvested', '1');
            var data;
            try {
                data = JSON.parse(node.textContent || '{}');
            } catch (error) {
                return;
            }
            Object.keys(data).forEach(function (key) {
                registry[key] = normalise(data[key]);
            });
        });

        root.querySelectorAll('[data-variant-sku-input]').forEach(function (input) {
            var form = input.form || input.closest('form');
            if (!form) return;
            var idField = form.querySelector('[name="id"]');
            if (!idField || !idField.value) return;
            if (registry[idField.value] === undefined) {
                registry[idField.value] = normalise(input.value);
            }
        });
    }

    function syncInputs(scope) {
        (scope || document).querySelectorAll('[data-variant-sku-input]').forEach(function (input) {
            var form = input.form || input.closest('form');
            if (!form) return;
            var idField = form.querySelector('[name="id"]');
            if (!idField) return;
            var sku = lookup(idField.value);
            if (typeof sku === 'string' && input.value !== sku) {
                input.value = sku;
            }
        });
    }

    function refresh() {
        harvest(document);
        syncInputs(document);
    }

    function schedule() {
        if (scheduled) return;
        scheduled = true;
        window.requestAnimationFrame(function () {
            scheduled = false;
            refresh();
        });
    }

    function decorateSearchParams(params) {
        if (params.get(PROPERTY_NAME)) return false;
        var sku = lookup(params.get('id'));
        if (!sku) return false;
        params.set(PROPERTY_NAME, sku);
        return true;
    }

    function decorateFormData(formData) {
        if (formData.get(PROPERTY_NAME)) return;
        var sku = lookup(formData.get('id'));
        if (!sku) return;
        formData.set(PROPERTY_NAME, sku);
    }

    function decorateJsonPayload(payload) {
        var changed = false;
        var items = payload && payload.items ? payload.items : payload ? [payload] : [];

        items.forEach(function (item) {
            if (!item || !item.id) return;
            var sku = lookup(item.id);
            if (!sku) return;
            item.properties = item.properties || {};
            if (item.properties.Artikelnummer) return;
            item.properties.Artikelnummer = sku;
            changed = true;
        });

        return changed;
    }

    function isCartAddUrl(url) {
        return typeof url === 'string' && url.indexOf('/cart/add') !== -1;
    }

    if (window.jQuery) {
        window.jQuery.ajaxPrefilter(function (options) {
            if (!isCartAddUrl(options.url) || typeof options.data !== 'string') return;
            var params = new URLSearchParams(options.data);
            decorateSearchParams(params);
            options.data = params.toString();
        });
    }

    var nativeFetch = window.fetch;
    if (typeof nativeFetch === 'function') {
        window.fetch = function (input, init) {
            try {
                var url = typeof input === 'string' ? input : (input && input.url) || '';
                var body = init && init.body;

                if (isCartAddUrl(url) && body) {
                    if (typeof FormData !== 'undefined' && body instanceof FormData) {
                        decorateFormData(body);
                    } else if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
                        decorateSearchParams(body);
                    } else if (typeof body === 'string') {
                        if (body.charAt(0) === '{') {
                            var payload = JSON.parse(body);
                            if (decorateJsonPayload(payload)) init.body = JSON.stringify(payload);
                        } else {
                            var params = new URLSearchParams(body);
                            if (decorateSearchParams(params)) init.body = params.toString();
                        }
                    }
                }
            } catch (error) {
                return nativeFetch.apply(window, arguments);
            }

            return nativeFetch.apply(window, arguments);
        };
    }

    function hasMarkers(node) {
        if (node.nodeType !== 1) return false;
        return node.matches(MARKERS) || !!node.querySelector(MARKERS);
    }

    document.addEventListener('change', schedule, true);
    document.addEventListener('DOMContentLoaded', refresh);

    new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
            var added = mutations[i].addedNodes;
            for (var j = 0; j < added.length; j++) {
                if (hasMarkers(added[j])) {
                    schedule();
                    return;
                }
            }
        }
    }).observe(document.documentElement, { childList: true, subtree: true });

    refresh();
})();
